import _WidgetBaseSP from 'more/_WidgetBaseSP';
import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './OMmusicianContractForm.html?raw';
import { AddressWizardTypes, AddressClassnames } from "../AddressWizardTypes";
import { OMclassnames, OMtypes } from "../../_loadingHelpers/OM";
import DateInput from '../../../moreCore/UI/DateInput/DateInput';
import '../../../moreCore/UI/DateInput/DateInput';
import '../../../moreCore/UI/SelectBox/SelectBox';

import HintBox from '../../../moreCore/UI/EntityBased/HintBox/HintBox';
import '../../../moreCore/UI/EntityBased/HintBox/HintBox';
import '../../../moreCore/UI/Edit/Edit';
import NumberInput from '../../../moreCore/UI/NumberInput/NumberInput';
import '../../../moreCore/UI/NumberInput/NumberInput';
import CheckBox from '../../../moreCore/UI/CheckBox/CheckBox';
import '../../../moreCore/UI/CheckBox/CheckBox';
import "../../../moreCore/UI/EntityBased/MultiselectBox/MultiselectBox"
import { ExpandableSectionMarkings, ExpandableSection, HTMLElementWithExpander } from "../../../moreCore/UI/Container/ExpandableSectionTypes";
import SearchSelect from '../../../moreCore/UI/SearchSelect/SearchSelect';
import "../../../moreCore/UI/SearchSelect/SearchSelect";
import "../../../moreCore/_loadingHelpers/SelectEntityDialog";
import EntityStore from '../../../moreCore/Tools/EntityStore';
import StaticTable from '../../../moreCore/UI/StaticTable/StaticTable';

interface OMmusicianContractFormResult extends OMtypes.musicianContract {
    professionsDiff: EntityStoreData<OMtypes.musicianEngagementEvProfession>,
    contractElementsDiff: EntityStoreData<OMtypes.musicianContractElement>,
}

class OMmusicianContractForm extends compose(_WidgetBaseSP) {
    templateString: any = template;


    private MusicianDataExpander: MdsLax<InstanceType<typeof ExpandableSection>>;
    private inputFunctionalSubGroup: MdsLax<InstanceType<typeof SearchSelect>>;
    private inputServiceObligation: MdsLax<InstanceType<typeof NumberInput>>;
    private musicianContractType: MdsLax<InstanceType<typeof SearchSelect>>;
    private contractStartDate: MdsLax<InstanceType<typeof DateInput>>;
    private contractEndDate: MdsLax<InstanceType<typeof DateInput>>;
    private inputProfession: MdsLax<InstanceType<typeof HintBox>>;
    private contractElementsTableContainer: HTMLElement;
    private professionsTableContainer: HTMLElement;
    private addFunctionalSubGroupButton: HTMLButtonElement;
    private addProfessionButton: HTMLButtonElement;

    private sectionAddContractElement: HTMLElement;
    private sectionAddProfession: HTMLElement;

    private contractElementsStore: MdsLax<InstanceType<typeof EntityStore<OMtypes.musicianContractElement>>>;
    private contractElementsTable: MdsLax<InstanceType<typeof StaticTable>>;

    private professionsStore: MdsLax<InstanceType<typeof EntityStore<OMtypes.musicianEngagementEvProfession>>>;
    private professionsTable: MdsLax<InstanceType<typeof StaticTable>>;

    private cbIsActive: MdsLax<InstanceType<typeof CheckBox>>;
    private cbIsTemplate: MdsLax<InstanceType<typeof CheckBox>>;

    private saveBtnContainer: HTMLElement

    private entity: OMtypes.musicianContract;

    private callback: Function;

    private _loadState: "loading" | "ready" = "ready";

    private _emitHandle: number = null;

    setup(entityData: OMtypes.musicianContract) {

        this.entity = entityData;

        console.log(this.id + " setup", entityData);
        this._loadState = "loading";
        this.setValues();
        setTimeout(lang.hitch(this, function () { this._loadState = "ready"; }), 120);

        //this.startup();
        this._recalcRemainingServiceObligation();

    }


    private setValues() {

        let entity: OMtypes.musicianContract = this.entity;


        this.professionsStore.setup(entity.EL_engagement_ev_profession_musican_contract_md);
        this.setupProfessionsTable();

        this.contractElementsStore.setup(entity.EL_contract_data_element_orch_musican_contract_md);
        this.setupContractElementsTable();


        this.musicianContractType.setValue(entity.ref_musican_contract_type, true);
        this.contractStartDate.setValue(entity.date_valid_from, true);
        this.contractEndDate.setValue(entity.date_valid_until, true);
        this.cbIsActive.setValue(entity.is_active, true);
        this.cbIsTemplate.setValue(entity.is_dummy, true);


    }

    private _onChange_StoreData_Professions() {
        let diffData = this.professionsStore.getDiffData();
        let completeList = this.professionsStore.getCurrentCompleteList();

        if (!this.professionsTable) {
            this.setupProfessionsTable();
        }

        //console.debug(this.id + ": _onChange_StoreData in EntityStore", diffData);

        if (this._emitHandle) {
            clearTimeout(this._emitHandle);
        }

        this._emitHandle = setTimeout(lang.hitch(this, this.emit, "change", diffData), 100);
    }

    private setupProfessionsTable(): void {

        this.UiModder.domConstruct.empty(this.professionsTableContainer);

        this.professionsTable = new StaticTable();

        this.professionsTable.placeAt(this.professionsTableContainer);


        let professionsTableLayout: StaticTable.RowConfig = {
            colNamesInternal: ["profession"],
            "attributes": ["ref_ev_profession.description"],
            "colspans": [1],
            "headings": [this.translate("General_Label_Profession")],
            widths: [null],
            alignmentsHeading: [null],
            alignmentsRow: [null],
            bgColors: [null]
        };

        this.professionsTable.addLineConfig(professionsTableLayout);
        this.professionsTable.setCyAttribute("OMmusicianContractProfessions");

        if (!this.isReadonly) {
            if (this.hasUserRole(["OM_MusicianData_Delete"])) this.professionsTable.addDefaultRowActionButton("delete");
        }

        //this.table.setData(this.entitylist);
        this.professionsTable.setupFromStore(this.professionsStore);

    }
    private setupContractElementsTable(): void {

        this.UiModder.domConstruct.empty(this.contractElementsTableContainer);

        this.contractElementsTable = new StaticTable();

        this.contractElementsTable.placeAt(this.contractElementsTableContainer);

        let contractElementsTableLayout: StaticTable.RowConfig = {
            colNamesInternal: ["functionalSubgroup", "compulsor_service_rate"],
            "attributes": ["ref_functional_sub_group.description", "compulsor_service_rate"],
            "colspans": [1, 1],
            "headings": [this.translate("General_Label_FunctionalSubGroup"), this.translate("OM_MusicianContract_Compulsor_Service_Rate")]
        }
        this.contractElementsTable.addLineConfig(contractElementsTableLayout);
        this.contractElementsTable.setCyAttribute("OMmusicianContractElements");
        if (!this.isReadonly) {
            if (this.hasUserRole("OM_MusicianData_Delete")) this.contractElementsTable.addDefaultRowActionButton("delete");
        }

        //this.table.setData(this.entitylist);
        this.contractElementsTable.setupFromStore(this.contractElementsStore);
    }

    private _onChange_StoreData_ContractElements() {
        let diffData = this.contractElementsStore.getDiffData();

        this._recalcRemainingServiceObligation();

        if (!this.contractElementsTable) {
            this.setupContractElementsTable();
        }

        this.emitDelayedChange();
    }

    private _recalcRemainingServiceObligation() {
        // aktuelle Verpflichtung zählen
        let serviceObligation = 100;

        let completeList = this.contractElementsStore.getCurrentCompleteList();
        for (let entity of completeList) {
            if (entity.compulsor_service_rate) {
                serviceObligation -= entity.compulsor_service_rate;
            }
        }

        if (serviceObligation < 0) serviceObligation = 0;
        this.inputServiceObligation.setValue(serviceObligation);
    }


    getValues(): Partial<OMmusicianContractFormResult>{

        let result: Partial<OMmusicianContractFormResult> = {
            ID: this.entity ? this.entity.ID : "",
            contractElementsDiff: this.contractElementsStore.getDiffData(),
            professionsDiff: this.professionsStore.getDiffData(),
            date_valid_from: this.contractStartDate.getValue(),
            date_valid_until: this.contractEndDate.getValue(),
            ref_musican_contract_type: this.musicianContractType.getValue(true),
            EL_engagement_ev_profession_musican_contract_md: this.professionsStore.getCurrentCompleteList(),
            EL_contract_data_element_orch_musican_contract_md: this.contractElementsStore.getCurrentCompleteList(),
            is_active: this.cbIsActive.getValue(),
            is_dummy: this.cbIsTemplate.getValue()
        }

        console.log("contractdata values", result);

        return result;
    }

    private _onValueChange_General() {
        this.emitDelayedChange();
    }

    // aktiv und template schließen sich gegenseitig aus!
    private _onValueChange_CbActive() {
        let value = this.cbIsActive.getValue();

        if (value === true) this.cbIsTemplate.setValue(false, true);

        this._onValueChange_General();
    }

    private _onValueChange_CbTemplate() {
        let value = this.cbIsTemplate.getValue();

        if (value === true) this.cbIsActive.setValue(false, true);

        this._onValueChange_General();
    }

    private _onValueChange_serviceObligation() {

    }

    private _onValueChange_functionalSubGroup() {
        let value = this.inputFunctionalSubGroup.getValue(true);
        this.disableNode(this.addFunctionalSubGroupButton, !value);
    }
    private _onValueChange_profession(value: AddressWizardTypes.Profession) {
        this.disableNode(this.addProfessionButton, !value);
    }

    private emitDelayedChange() {
        if (this._emitHandle) {
            clearTimeout(this._emitHandle);
        }

        if (this._loadState != "ready") return;

        this._emitHandle = setTimeout(lang.hitch(this, this.emit, "change"), 100);
    }

    private _onClick_AddFunctionalSubGroup_Button() {
        let serviceObligationValue: number;
        this.inputFunctionalSubGroup.setMandatory(true);
        this.inputServiceObligation.setMandatory(true);

        let functionalSubGroupIsValid = this.inputFunctionalSubGroup.validateInput();
        let serviceObligationIsValid = true; // this.serviceObligation.validateInput();
        serviceObligationValue = this.inputServiceObligation.getValue();
        serviceObligationValue = !serviceObligationValue ? 0 : serviceObligationValue;

        let sum = 0;


        if (functionalSubGroupIsValid) {

            let subGroupEntity: OMtypes.functionalSubGroup = this.inputFunctionalSubGroup.getValue(true);
            let functionalSubGroupValue: Partial<OMtypes.musicianContractElement> = {
                compulsor_service_rate: serviceObligationValue,
                ref_functional_sub_group: subGroupEntity
            }

            this.contractElementsStore.addEntry(functionalSubGroupValue as any)

            this.inputFunctionalSubGroup.setValue("", true);

        }
    }

    private _onClick_AddProfession_Button() {
        let professionValue = this.inputProfession.getValue("entity");
        let professionIsValid = this.inputProfession.validateInput();

        if (professionIsValid && professionValue) {

            let newEntry: Partial<OMtypes.musicianEngagementEvProfession> = {
                ref_ev_profession: professionValue
            };
            this.professionsStore.addEntry(newEntry as any);

            this.inputProfession.setValue(null);
            this.disableNode(this.addProfessionButton);
        }
    }

    private _loadFunctionalSubGroup() {
        var url = window.appRoot + "AddressWizard/GetFunctionalSubGroupList";

        this.RequestManager.post(
            url,
            {},
            lang.hitch(this, this._onLoadFunctionalSubGroupResponse),
            lang.hitch(this, this._onLoadFunctionalSubGroupError),
            false // sync
        );
    }

    private _onLoadFunctionalSubGroupResponse(response: Array<OMtypes.functionalSubGroup>) {

        this.inputFunctionalSubGroup.labelAttribute = "description";
        this.inputFunctionalSubGroup.valueAttribute = "ID";
        this.inputFunctionalSubGroup.setSelectionListLEGACY(response)

        this.StandbyStop();
    }

    private _onLoadFunctionalSubGroupError(err: more.requestErrorMessage) {
        alert("ERROR bei _getFunctionalSubGroup: " + err.Message);
    }


    private checkSectionContents(): void {


    }

    private _handlePrivileges() {
        if (!this.hasUserRole("OM_MusicianData_Edit")) {
            this.setReadonly(true);
        }
    }

    private isReadonly: boolean = false;
    setReadonly(readonly: boolean = true) {

        this.isReadonly = readonly;

        this.disableNode(this.contractStartDate, readonly);
        this.disableNode(this.contractEndDate, readonly);
        this.disableNode(this.musicianContractType, readonly);
        this.disableNode(this.cbIsActive, readonly);
        this.disableNode(this.cbIsTemplate, readonly);

        this.hideNode(this.sectionAddContractElement, readonly);
        this.hideNode(this.sectionAddProfession, readonly);
    }

    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        //on(this.domNode, "click", function (evt) { evt.stopPropagation(); })

        this.contractElementsStore = new EntityStore();
        this.contractElementsStore.on("change", lang.hitch(this, this._onChange_StoreData_ContractElements));

        this.professionsStore = new EntityStore();
        this.professionsStore.on("change", lang.hitch(this, this._onChange_StoreData_Professions));

        this.inputServiceObligation.setValue(100);

        this.hasUserRole("dummy", lang.hitch(this, this._handlePrivileges));
    }

    startup(): void {
        super.startup.apply(this, arguments as any);

        //this._loadFunctionalSubGroup();

        this.UiModder.domConstruct.destroy(this.inputServiceObligation.unit_node);
        this.inputProfession.enablePlainTextValue = false;


        //this.profession.enableSelectEntityDialog(true);
        //this.organisation.enableSelectEntityDialog(true);

        this.musicianContractType.loadListValues();

        if (!this.entity) {
            this.cbIsActive.setValue(true);
        }

    }
}

export default mdsWidget(OMmusicianContractForm);
